import { ViewIds } from '@ardoq/api-types';
import { derivedStream, spreadMap, toPersistentStream } from '@ardoq/rxbeach';
import { distinctUntilChanged } from 'rxjs/operators';
import { isEqual } from 'lodash';
import { type ModeViews, viewpointModeViews$ } from 'views/modeViews$';
import { ViewpointModeViewKey } from 'views/environmentals/viewSettings/types';
import { isViewpointModeView } from 'views/environmentals/viewSettings/utils';
import { RequestedTabs, requestedTabs$ } from './requestedTabs$';
import { MainViewTab } from './types';

export type ViewpointModeTab = MainViewTab & {
  activeTabId: ViewpointModeViewKey | ViewIds.NONE;
};

const NO_VIEWPOINT_MODE_TAB: ViewpointModeTab = {
  activeTabId: ViewIds.NONE,
  metaInfo: null,
};

export const toViewpointModeTab = (
  {
    isViewpointMode: isRequestedInViewpointMode,
    activeTabIdLeft,
  }: RequestedTabs,
  { byIds }: ModeViews<ViewIds>
): ViewpointModeTab => {
  if (isRequestedInViewpointMode && isViewpointModeView(activeTabIdLeft)) {
    return {
      activeTabId: activeTabIdLeft,
      metaInfo: byIds[activeTabIdLeft] ?? null,
    };
  }

  return NO_VIEWPOINT_MODE_TAB;
};

export const viewpointModeTab$ = toPersistentStream<ViewpointModeTab>(
  'viewpointModeTab$',
  derivedStream('viewpointModeTab$', requestedTabs$, viewpointModeViews$).pipe(
    spreadMap(toViewpointModeTab),
    distinctUntilChanged(isEqual)
  ),
  NO_VIEWPOINT_MODE_TAB
);
